import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PagerService } from '../../services/index';
import * as $ from 'jquery';


@Component({
  selector: 'app-user-credit-transaction-report',
  templateUrl: './user-credit-transaction-report.component.html',
  styleUrls: ['./user-credit-transaction-report.component.css']
})
export class UserCreditTransactionReportComponent implements OnInit {

	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: number = 10;
	pageNo: any = 1;
	time: any = 0;
	listType: any;
	prev_token:any;
	transactionReport: any[];
	isReportAvailable: boolean = true;
	reportDate: any;
	redirectUrl: any;
	activePageNo: any = 0;
	appPurchaseArr: any = [];
	userAllTransactionList: any = [];
	userTransactionList: any = [];
	isAllUserTransactionAvailable: boolean = false;
	userName: any
	totalcredit: number = 0
	CRblance: number = 0;
	totalCr: number = 0;
	totalDr: number = 0;
	availableCredit: number = 0
	constructor(private router: Router, private activatedRoute: ActivatedRoute, private pagerService: PagerService, private authService: AuthService,
		private commonService: CommonService) { }

	ngOnInit() {
   
    
    this.time=1;
    this.activatedRoute.params.subscribe((params: any) => {
      

      if (params.listType==='1'){
		this.userName= params.user_name
		const prev_token = params.prev_token.split('=')
		this.prev_token=+prev_token[1]
		this.getUserCreditReport(params.user_id);
		
      
      }
      else {
		this.activatedRoute.params.subscribe((params: any) => {
			
			if(params.prev_token){
				this.pageNo = +params.prev_token;
				this.getAllUserCreditTransactionReport(this.pageNo, this.limit)
			}else{
				this.getAllUserCreditTransactionReport(this.pageNo, this.limit)	
			}
		}) 
       
      }
    })
		this.commonService.process();
		$('.navbar-brand').text('User Credit Transactions Report');
		

  
			}

	

  

  // Get user credit transaction reprot
  
  getAllUserCreditTransactionReport = function (pageNo, limit){
    this.authService.getAllUserCreditTransactionReport(pageNo, limit).subscribe(data=>{
      
      if(data.success){
     
        console.log(data,'report')
        this.userAllTransactionList = data.transactions.docs;
        this.total = data.transactions.total;
        this.setPage(pageNo, true,);
        this.pageNo = pageNo
        this.isAllUserTransactionAvailable=true;
        this.redirectUrl = "pageNo="+pageNo;
        this.listType=1
      }
      else{
        this.userAllTransactionList =[]
        this.isAllUserTransactionAvailable=false
      
        
	  }
	  this.commonService.hideProcess();
    })
    
  }


  
  // Get user credit transaction reprot
  
  getUserCreditReport = function (userId){
   
    this.authService.getUserCreditReport(userId).subscribe(data=>{
      
      if(data.success){
		  var newArrry = []
		  data.transactions.forEach((element, index) => {
			  
			  if(element.earnorredeem==='earn'){
				const credit = +element.noofcredit;
				const newCredit = +this.totalcredit+credit;
				const balance = +newCredit-0
				this.totalcredit = balance;
				this.totalCr= +this.totalCr+credit
				if(balance<0){
				element.balance = 0;
				}else{
				element.balance = balance;
				}
				
				 newArrry.push(element)
			 }
			 else if(element.earnorredeem==='redeem'){
				const debit = +element.noofcredit;
				const newdebit = +this.totalcredit-debit;
				const balance = +newdebit-0
				this.totalcredit =balance;
				this.totalDr= +this.totalDr+debit
				if(balance<0){
				element.balance = 0
				}else{
				element.balance =balance;
				}
				
				 newArrry.push(element)
			 }
			  
		  });
    debugger
		this.userAllTransactionList = newArrry;
		  this.availableCredit = this.totalCr - this.totalDr;
		  if (this.availableCredit < 0) {
			  this.availableCredit = 0;
		  } else
			  this.availableCredit = this.totalCr - this.totalDr;
	     //this.total = data.transactions.total;
       // this.setPage(pageNo, true,);
        //this.pageNo = pageNo
        this.isAllUserTransactionAvailable=true;
		this.isUserTransactionAvailble = true
		this.listType=2
		
        
      }
      else{
        this.userTransactionList =[]
        this.userAllTransactionList =[]
        this.isUserTransactionAvailble = false
       
	  }
	  this.commonService.hideProcess();
    })
    
  }

  myClickFunction(pageNo) { 
	  
	  this.router.navigate(['user-credit-transaction-report/'+ this.prev_token]);

 }
	

	// Search Report
	searchReport = function(time){
		this.time = time;
		this.getTransactionReport(1, this.limit, time);
	}

	// Pagination
  setPage(page: number, param) {
    
		// $('.pages.active a').each(function(){
		// 	if(parseInt($(this).text()) != page)
		// 		$(this).parent('li').removeClass('active');
		// });
		// if($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
		// 	$('#first, #prev').removeClass('disabled');
		// if($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
		// 	$('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.userAllTransactionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getAllUserCreditTransactionReport(page, this.limit, );
		}
	}

	// Change title
	changeTitle = function(time){
		if(time=='1'){
			$(".navbar-brand").text("Daily Transactions Report");
		}
		else if(time=='2'){
			$(".navbar-brand").text("Weekly Transactions Report");
		}
		else if(time=='3'){
			$(".navbar-brand").text("Monthly Transactions Report");
		}	
		else{
			$(".navbar-brand").text("Yearly Transactions Report");
		}
	}

	// Get current Date
	getReportDate = function (time) {
		var month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		var MyDate = new Date();
		var toDateString = ('0' + MyDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ MyDate.getFullYear();

		var newDate = MyDate;
		if (time === "2")
			newDate.setDate(newDate.getDate() - 7);
		if (time === "3")
			newDate.setMonth(newDate.getMonth() - 1)
		if (time === "4")
			newDate.setFullYear(newDate.getFullYear() - 1);

		var fromDateString = ('0' + newDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ newDate.getFullYear();
		if (time != 1) {
			this.reportDate = "From " + fromDateString + " to " + toDateString;
			$('.report_period').css("padding-left", "");
		}
		else {
			this.reportDate = "Today";
			$('.report_period').css("padding-left", 200 + "px");
		}
	}

}




// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/user-credit-transaction-report/user-credit-transaction-report.component.ts